import jwtDecode from 'jwt-decode';
import { AuthServiceBase } from './service-auth-base';

export const MSX_AUTH_NOT_FOUND = 'MSXAuthService: MsxAuthenticationService not found';

export class MSXAuthService extends AuthServiceBase {
  public getAccountInfo = (): Promise<any> =>
    new Promise((resolve, reject) => {
      this.getTokenForScope(this.GRAPH_AUTH_SCOPE).catch((error: Error) => {
        reject(error);
      });
      this.getTokenForScope(this.MEM_AUTH_SCOPE)
        .then((token: string) => {
          const decoded: { upn?: string } = jwtDecode(token);
          resolve(decoded.upn);
        })
        .catch((error: Error) => {
          reject(error);
        });
    });

  public getTokenForScope = (scope: string): Promise<string> =>
    new Promise((resolve, reject) => {
      if (!(window as any)?.MsxAuthenticationService) {
        reject(new Error(MSX_AUTH_NOT_FOUND));
      } else {
        (window as any).MsxAuthenticationService.acquireTokenForScope(scope)
          .then((token: string) => {
            resolve(token);
          })
          .catch((error: Error) => {
            reject(error);
          });
      }
    });
}
